import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["integrationsPlatformAppId", "providerName", "ready"];
import { useCallback } from 'react';
import memoizeWithTimeout from '../utils/memoize';
import { CALLING_ORCH_SETTINGS_USER_API_V1, fetchCallingPreferencesProvider } from '../http/fetchCallingPreferencesProvider';
import * as AsyncStatuses from 'calling-integration-sdk-support/async-data/constants/AsyncStatuses';
import { logNetworkError } from 'calling-error-reporting/report/error';
import { HUBSPOT } from 'calling-internal-common/call-provider/constants/ProviderNames';
import { getPersistedCallProvider } from 'calling-lifecycle-internal/utils/getLocalCallSettings';
const getCallProviderName = name => name.toLowerCase() === HUBSPOT.toLowerCase() ? HUBSPOT : name;
const getCallProviderInfo = _ref => {
  let {
      integrationsPlatformAppId,
      providerName,
      ready
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return Object.assign({
    appId: integrationsPlatformAppId,
    name: providerName,
    isReady: ready
  }, rest);
};
let memoizedFetchCallingPreferencesProvider = memoizeWithTimeout(() => {
  return fetchCallingPreferencesProvider();
}, 5000);
const noOp = () => {};
export const useCallingPreferencesProvider = ({
  setIsUserPreferencesProviderUnset
}) => {
  const getCallingPreferencesProvider = useCallback((updateSelectedCallProvider = noOp) => {
    const persistedProvider = getPersistedCallProvider();
    return memoizedFetchCallingPreferencesProvider().then(results => {
      let providerInfo;
      if (results.callingProviderInfo.integrationsPlatformAppId) {
        providerInfo = getCallProviderInfo(results.callingProviderInfo.metadata.result);
      } else {
        providerInfo = {
          name: getCallProviderName(results.callingProviderInfo.callingProvider)
        };
      }
      updateSelectedCallProvider({
        data: providerInfo,
        status: AsyncStatuses.SUCCEEDED
      });
      setIsUserPreferencesProviderUnset((persistedProvider === null || persistedProvider === void 0 ? void 0 : persistedProvider.name) !== providerInfo.name);
      return providerInfo;
    }).catch(networkError => {
      logNetworkError({
        networkError,
        error: new Error('Error fetching calling preferences provider'),
        tags: {
          requestName: CALLING_ORCH_SETTINGS_USER_API_V1
        }
      });
      updateSelectedCallProvider({
        status: AsyncStatuses.FAILED
      });
    });
  }, [setIsUserPreferencesProviderUnset]);
  return getCallingPreferencesProvider;
};
export const clearMemoizedFetchForTesting = () => {
  memoizedFetchCallingPreferencesProvider = fetchCallingPreferencesProvider;
};